// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactHeader {
  background-color: #3fb9ea;
  color: white;
  padding: 15px;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
}
.contactHeader .leftHeader h1 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}
.contactHeader .rightHeader nav ol.breadcrumb li.breadcrumb-item a.inActive {
  color: white;
}
.contactHeader .rightHeader nav ol.breadcrumb li.breadcrumb-item.active a {
  color: white;
}

.contact {
  background-color: white;
  border-radius: 0 0 8px 8px;
  padding: 20px;
}
.contact .locationContainer {
  margin: 20px 0;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.contact .locationContainer iframe {
  width: 100%;
  height: 350px;
  border: 0;
  border-radius: 8px;
}
.contact .locationContainer h4.title {
  color: #d60000;
  font-size: 20px;
  font-weight: bold;
}
.contact .locationContainer .locationNames {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.contact .locationContainer .locationNames .locationName i.fas {
  font-size: 20px;
  color: #3fb9ea;
  margin-right: 10px;
}
.contact .locationContainer .locationNames .locationDisc {
  display: inline-block;
}
.contact .locationContainer .locationNames .locationDisc h6 {
  color: #3fb9ea;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}
.contact .locationContainer .locationNames .locationDisc p.disc {
  font-size: 16px;
  margin: 0;
}
.contact .locationContainer .locationNames .locationDisc p.disc i.fas {
  color: #3fb9ea;
  margin-right: 5px;
}
.contact .locationContainer .locationNames .locationDisc p.disc a {
  color: #000;
  text-decoration: none;
}
.contact .locationContainer .locationNames .locationDisc p.disc a:hover {
  color: #b80000;
}
.contact .locationContainer a.btn {
  padding: 5px 10px;
  background-color: #3fb9ea;
  border-radius: 20px;
  color: #fff;
  text-decoration: none;
  transition: all 300ms ease-in-out;
}
.contact .locationContainer a.btn i.fas {
  font-size: 16px;
  margin-left: 5px;
}
.contact .locationContainer a.btn:hover {
  background: #b80000;
  color: #fff;
}
.contact .contactOuterTitle {
  padding-left: 1%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Contacts/Style.scss"],"names":[],"mappings":"AAMA;EACI,yBANM;EAON,YAAA;EACA,aAAA;EACA,0BAAA;EACA,aAAA;EACA,8BAAA;AALJ;AAQQ;EACI,eAAA;EACA,iBAAA;EACA,SAAA;AANZ;AAewB;EACI,YAAA;AAb5B;AAkBwB;EACI,YAAA;AAhB5B;;AAyBA;EACI,uBAAA;EACA,0BAAA;EACA,aAAA;AAtBJ;AAwBI;EACI,cAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;AAtBR;AAwBQ;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AAtBZ;AAyBQ;EACI,cA7DA;EA8DA,eAAA;EACA,iBAAA;AAvBZ;AA0BQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAxBZ;AA2BgB;EACI,eAAA;EACA,cA3EV;EA4EU,kBAAA;AAzBpB;AA6BY;EACI,qBAAA;AA3BhB;AA4BgB;EACI,cAnFV;EAoFU,eAAA;EACA,iBAAA;EACA,SAAA;AA1BpB;AA6BgB;EACI,eAAA;EACA,SAAA;AA3BpB;AA6BoB;EACI,cA9Fd;EA+Fc,iBAAA;AA3BxB;AA8BoB;EACI,WAAA;EACA,qBAAA;AA5BxB;AA8BwB;EACI,cArGpB;AAyER;AAmCQ;EACI,iBAAA;EACA,yBAhHF;EAiHE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;AAjCZ;AAmCY;EACI,eAAA;EACA,gBAAA;AAjChB;AAoCY;EACI,mBA1HR;EA2HQ,WAAA;AAlChB;AAuCI;EACI,gBAAA;AArCR","sourcesContent":["// Color Variables\r\n$primary: #3fb9ea;\r\n$secondary: #d60000;\r\n$hover: #b80000;\r\n$gray: #808080;\r\n\r\n.contactHeader {\r\n    background-color: $primary;\r\n    color: white;\r\n    padding: 15px;\r\n    border-radius: 8px 8px 0 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    .leftHeader {\r\n        h1 {\r\n            font-size: 24px;\r\n            font-weight: bold;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .rightHeader {\r\n        nav {\r\n            ol.breadcrumb {\r\n                li {\r\n                    &.breadcrumb-item {\r\n                        a.inActive {\r\n                            color: white;\r\n                        }\r\n                    }\r\n\r\n                    &.breadcrumb-item.active {\r\n                        a {\r\n                            color: white;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.contact {\r\n    background-color: white;\r\n    border-radius: 0 0 8px 8px;\r\n    padding: 20px;\r\n\r\n    .locationContainer {\r\n        margin: 20px 0;\r\n        background-color: white;\r\n        padding: 20px;\r\n        border-radius: 8px;\r\n        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\r\n\r\n        iframe {\r\n            width: 100%;\r\n            height: 350px;\r\n            border: 0;\r\n            border-radius: 8px;\r\n        }\r\n\r\n        h4.title {\r\n            color: $secondary;\r\n            font-size: 20px;\r\n            font-weight: bold;\r\n        }\r\n\r\n        .locationNames {\r\n            display: flex;\r\n            align-items: center;\r\n            margin-top: 10px;\r\n\r\n            .locationName {\r\n                i.fas {\r\n                    font-size: 20px;\r\n                    color: $primary;\r\n                    margin-right: 10px;\r\n                }\r\n            }\r\n\r\n            .locationDisc {\r\n                display: inline-block;\r\n                h6 {\r\n                    color: $primary;\r\n                    font-size: 18px;\r\n                    font-weight: bold;\r\n                    margin: 0;\r\n                }\r\n\r\n                p.disc {\r\n                    font-size: 16px;\r\n                    margin: 0;\r\n\r\n                    i.fas {\r\n                        color: $primary;\r\n                        margin-right: 5px;\r\n                    }\r\n\r\n                    a {\r\n                        color: #000;\r\n                        text-decoration: none;\r\n\r\n                        &:hover {\r\n                            color: $hover;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        a.btn {\r\n            padding: 5px 10px;\r\n            background-color: $primary;\r\n            border-radius: 20px;\r\n            color: #fff;\r\n            text-decoration: none;\r\n            transition: all 300ms ease-in-out;\r\n\r\n            i.fas {\r\n                font-size: 16px;\r\n                margin-left: 5px;\r\n            }\r\n\r\n            &:hover {\r\n                background: $hover;\r\n                color: #fff;\r\n            }\r\n        }\r\n    }\r\n\r\n    .contactOuterTitle {\r\n        padding-left: 1%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
